// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"67":"bill","231":"checkout"}[chunkId] + "." + {"67":"c0accdae","231":"8fd95df2"}[chunkId] + ".js";
};